var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 37,
    viewBox: "0 0 46 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.998535,
    y: 0.643555,
    width: 45,
    height: 36,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_158_1088",
    transform: "scale(0.0222222 0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_158_1088",
    width: 45,
    height: 36,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAkCAYAAAAdFbNSAAACjUlEQVRYCcWZ21HDMBBFXUJ+GGTzszNS/imBDqAD6IB0QDqIOwgdUAIlpISUQAlhriU5tqyHZW1iZjK29TxaXa1Woqru+PdE2+eaZFuTOjWk/mpSF/P8FSTfBRHFcLz5G6JNrNLSPLRbkzoAMv6TZ8C7/QhSLzWpbmBuXtWQ/G5IfU0yChJgnZrkOQ47HgwYAIonYHVdeZ5gkLZGZwlO8Fzg0OAgrQm0mYJ++jjAjaX6NkNAsXRoXpD8ADAY8evhkeGpfOgLZL7omcuThaf/i+gkK496xqD5wWINQF9QeFRwJny4vbF+faC+NFh8IpFUJ5jqHO9iXFuRNCy8FxjG06s8ZQW/S/IZ/7rqU22m8hMzPb8jeW5IHh98K9qMYH5bcWgowGeUPi0lETtd46ceADaF4SCwgMbl4nChsklo0HNYCBrELwSSkx6Fth6Cy1XlgMXKPpJ67aXgvghSe+ML25q2n1w7WQxoTt5oM5lCezcXFpc1By5UJupmh7FHqIEV0k+ucSffHIuQc2CC5HEC6SboIH2Za+KEtW1FF+EQvia1s5XWfkb1PITGu/Yk61p8ljRc8Ibk25puL+rqXFh8Y1rs1Gi5lMfFOVITpH59XNE0uD+ubTgH1pbNtrIdDWc8bGHmPBdp2UKvEYNgdm0MZDmyn/pgcFc977IhfRUAzhUbx+UhW1//RWlYHPpkzBMnOwNIxxhF9FVVcdxnXKETZ8BSWFibOag62f2glG1S/waw3SVMEfCwMhYeDqj6kCtb7k3GtFfuJQxg1s3mVZNZgdVPsR92dXAreMQSi7dmFzL0bd1bSZRnQPdD6YX6Y0/Xi7A7nbcAwb8eRHcp2V2R4eYeskIabjZbhLS3Bv0HuJQsL7i2F8QAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner6);
export default __webpack_public_path__ + "static/media/partner6.fbee8245c62a2805e3a3b1c8551e0083.svg";
export { ForwardRef as ReactComponent };